import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth-guard.service';
import { NotFoundPageComponent } from './components/not-found-page.component';

export const ROUTES: Routes = [
  {
    path: 'admin-borrower',
    loadChildren: () =>
      import('./_borrower/admin.module').then(m => m.AdminBorrowerModule),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'admin-investor',
    loadChildren: () =>
      import('./_investor/admin.module').then(m => m.AdminInvestorModule),
    canActivate: [AuthGuard],
    data: { preload: true },
  },
  {
    path: 'myinfo_callback',
    loadChildren: () =>
      import('./_public/myinfo-callback/myinfo-callback.module').then(
        m => m.MyInfoCallbackModule
      ),
  },
  {
    path: 'log-in',
    loadChildren: () =>
      import('./_public/log-in/log-in.module').then(m => m.LogInModule),
  },
  {
    path: 'password',
    loadChildren: () =>
      import('./_public/password/password.module').then(m => m.PasswordModule),
  },
  {
    path: 'rdl-notice',
    loadChildren: () =>
      import('./_public/rdl-term-condition/rdl-term-condition.module').then(
        m => m.RdlTermConditionModule
      ),
  },
  {
    path: 'statistics',
    redirectTo: 'progress',
    pathMatch: 'full',
  },
  {
    path: 'investor-loyalty',
    loadChildren: () =>
      import('./_public/loyalty/loyalty.module').then(m => m.LoyaltyModule),
  },
  {
    path: 'progress',
    loadChildren: () =>
      import('./_public/progress/progress.module').then(m => m.ProgressModule),
  },
  {
    path: 'response',
    loadChildren: () =>
      import('./_public/response/response.module').then(m => m.ResponseModule),
  },
  {
    path: 'sign-up/forms/borrower',
    loadChildren: () =>
      import('./_public/signup-form-borrower/signup-form-borrower.module').then(
        m => m.SignupFormBorrowerModule
      ),
  },
  {
    path: 'sign-up/forms/investor',
    loadChildren: () =>
      import('./_public/signup-form-investor/signup-form-investor.module').then(
        m => m.SignupFormInvestorModule
      ),
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./_public/forgot-password/forgot-password.module').then(
        m => m.ForgotPasswordModule
      ),
  },
  {
    path: 'term-condition-referral',
    loadChildren: () =>
      import(
        './_public/term-condition-referral/term-condition-referral.module'
      ).then(m => m.TermConditionReferralModule),
  },
  {
    path: 'term-condition-loyalty',
    loadChildren: () =>
      import(
        './_public/term-condition-loyalty/term-condition-loyalty.module'
      ).then(m => m.TermConditionLoyaltyModule),
  },
  {
    path: 'platform-agreement',
    loadChildren: () =>
      import('./_public/platform-agreement/platform-agreement.module').then(
        m => m.PlatformAgreementModule
      ),
  },
  {
    path: 'user-agreement',
    loadChildren: () =>
      import('./_public/platform-agreement/platform-agreement.module').then(
        m => m.PlatformAgreementModule
      ),
  },
  {
    path: 'investor-loyalty',
    loadChildren: () =>
      import('./_public/loyalty/loyalty.module').then(m => m.LoyaltyModule),
  },
  {
    path: 'allocation-policy',
    loadChildren: () =>
      import('./_public/allocation-policy/allocation-policy.module').then(
        m => m.AllocationPolicyModule
      ),
  },
  {
    path: 'sign-up',
    loadChildren: () =>
      import('./_public/sign-up/sign-up.module').then(m => m.SignUpModule),
  },
  {
    path: 'sign-up/investor',
    redirectTo: 'sign-up-investor',
    pathMatch: 'full',
  },
  {
    path: 'sign-up/borrower',
    redirectTo: 'sign-up-borrower',
    pathMatch: 'full',
  },
  {
    path: 'sign-up-investor',
    loadChildren: () =>
      import('./_public/sign-up/sign-up.module').then(m => m.SignUpModule),
  },
  {
    path: 'sign-up-borrower',
    loadChildren: () =>
      import('./_public/sign-up/sign-up.module').then(m => m.SignUpModule),
  },
  // {
  //   path: 'sbn-info',
  //   loadChildren: () => import('./_public/sbn-info/sbn-info.module').then(m => m.SbnInfoModule)
  // },
  {
    path: '',
    loadChildren: () =>
      import('./_public/home/home.module').then(m => m.HomeModule),
  },
  { path: '**', component: NotFoundPageComponent },
];
